/* KALMO° — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';

  // Cada seccion del tema incluye este archivo, asi que el navegador lo ejecuta
  // una vez por seccion (6 en la pagina de producto). Sin este candado, cada
  // init se registraba 6 veces y un solo gesto/clic contaba por 6.
  if (window.__mtKalmoListo) return;
  window.__mtKalmoListo = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal al hacer scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Cifras animadas (count-up) ---- */
  function initCounters() {
    var nums = document.querySelectorAll('[data-mt-count]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-mt-count') + (n.getAttribute('data-mt-suffix') || ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-mt-count'));
        var suffix = el.getAttribute('data-mt-suffix') || '';
        var dur = 1500, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = (target % 1 === 0 ? Math.round(val) : val.toFixed(1)) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Galería de la página de producto ---- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    galerias.forEach(function (g) {
      var main = g.querySelector('[data-mt-galeria-main]');
      var thumbs = g.querySelectorAll('[data-mt-galeria-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var src = t.getAttribute('data-src');
          if (src) main.src = src;
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  // Deslizar la foto grande con el dedo. Recorre solo las miniaturas VISIBLES,
  // asi respeta el filtro de fotos por oferta (pack / solo).
  function initSwipe() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    galerias.forEach(function (g) {
      var main = g.querySelector('[data-mt-galeria-main]');
      var zona = main && main.parentNode;
      if (!main || !zona) return;
      function visibles() {
        return [].slice.call(g.querySelectorAll('[data-mt-galeria-thumb]'))
          .filter(function (t) { return !t.hasAttribute('hidden') && t.offsetParent !== null; });
      }
      function mover(paso) {
        var vs = visibles();
        if (vs.length < 2) return;
        var actual = vs.findIndex(function (t) { return t.classList.contains('is-active'); });
        if (actual < 0) {
          actual = vs.findIndex(function (t) { return t.getAttribute('data-src') === main.getAttribute('src'); });
        }
        if (actual < 0) actual = 0;
        var i = (actual + paso + vs.length) % vs.length;
        vs[i].click();
      }
      var x0 = null, y0 = null;
      zona.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { x0 = null; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      zona.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0, dy = t.clientY - y0;
        x0 = null;
        // Solo si el gesto fue claramente horizontal, para no robarle el scroll vertical
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        mover(dx < 0 ? 1 : -1);
      }, { passive: true });
    });
  }

  /* ---- FAQ acordeón ---- */
  function initFaq() {
    var items = document.querySelectorAll('.mt-faq__item');
    items.forEach(function (item) {
      var q = item.querySelector('.mt-faq__q');
      var a = item.querySelector('.mt-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        if (open) {
          item.classList.remove('is-open');
          a.style.maxHeight = null;
        } else {
          item.classList.add('is-open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }

  /* ---- Comparador antes/después ---- */
  function initComparador() {
    var cmps = document.querySelectorAll('[data-mt-comparador]');
    cmps.forEach(function (cmp) {
      var range = cmp.querySelector('.mt-cmp__range');
      if (!range) return;
      function upd() { cmp.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', upd);
      upd();
    });
  }

  /* ---- Parallax suave del banner ---- */
  function initParallax() {
    if (reduce) return;
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length) return;
    var ticking = false;
    function apply() {
      ticking = false;
      var mobile = window.innerWidth < 750;
      els.forEach(function (el) {
        if (mobile) { el.style.transform = ''; return; }
        var rect = el.getBoundingClientRect();
        var offset = rect.top * -0.08;
        if (offset > 44) offset = 44; if (offset < -44) offset = -44;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.16)';
      });
    }
    function onScroll() { if (!ticking) { window.requestAnimationFrame(apply); ticking = true; } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    apply();
  }

  /* ---- Selector de ofertas (variantes) en la página de producto ---- */
  function initOferta() {
    var wraps = document.querySelectorAll('[data-mt-ofertas]');
    wraps.forEach(function (wrap) {
      var radios = wrap.querySelectorAll('[data-mt-oferta]');
      if (!radios.length) return;
      var hidden = document.querySelector('.mt-pdp__form input[name="id"]');
      var precioEl = document.querySelector('.mt-pdp__precio-actual');
      var incluyeEl = document.querySelector('[data-mt-incluye]');
      var mainImg = document.querySelector('[data-mt-galeria-main]');
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          wrap.querySelectorAll('.mt-oferta').forEach(function (l) { l.classList.remove('is-active'); });
          var label = r.closest('.mt-oferta');
          if (label) label.classList.add('is-active');
          if (hidden) hidden.value = r.value;
          var p = r.getAttribute('data-precio');
          if (precioEl && p) precioEl.textContent = p;
          var inc = r.getAttribute('data-incluye');
          if (incluyeEl && inc) incluyeEl.textContent = inc;
          /* Cada oferta muestra sus propias fotos. Las que no llevan palabra
             ("ambos") se ven siempre. */
          var esPack = (r.closest('.mt-oferta') || {}).classList
            ? r.closest('.mt-oferta').classList.contains('mt-oferta--destacada')
            : false;
          var setActivo = esPack ? 'pack' : 'solo';
          var visibles = [];
          document.querySelectorAll('[data-mt-galeria-thumb]').forEach(function (t) {
            var s = t.getAttribute('data-mt-set') || 'ambos';
            var ver = (s === 'ambos' || s === setActivo);
            t.hidden = !ver;
            t.classList.remove('is-active');
            if (ver) visibles.push(t);
          });

          /* La foto grande pasa a ser la primera visible de esa oferta */
          var nuevaSrc = visibles.length ? visibles[0].getAttribute('data-src') : r.getAttribute('data-img');
          if (mainImg && nuevaSrc) {
            mainImg.src = nuevaSrc;
            if (visibles.length) visibles[0].classList.add('is-active');
          }
        });
      });
    });
  }

  /* ---- Barra de anuncio (Dawn) convertida en cinta que se desplaza ---- */
  function initAnuncio() {
    var util = document.querySelector('.utility-bar');
    if (!util) return;
    var msgs = util.querySelectorAll('.announcement-bar__message');
    if (!msgs.length || util.querySelector('.mt-anuncio')) return;
    var unit = '';
    for (var m = 0; m < msgs.length; m++) {
      unit += '<span class="mt-anuncio__item">' + msgs[m].innerHTML + '</span>';
    }
    var reps = Math.max(2, Math.ceil(8 / msgs.length));
    var half = '';
    for (var i = 0; i < reps; i++) half += unit;
    var wrap = document.createElement('div');
    wrap.className = 'mt-anuncio';
    var track = document.createElement('div');
    track.className = 'mt-anuncio__track';
    track.innerHTML = half + half;
    wrap.appendChild(track);
    var grid = util.querySelector('.utility-bar__grid');
    if (grid) grid.style.display = 'none';
    util.appendChild(wrap);
  }


  // Botones - y + del selector de cantidad
  function initCantidad() {
    var campos = document.querySelectorAll('.mt-cant__n');
    for (var i = 0; i < campos.length; i++) {
      (function (input) {
        var caja = input.closest('.mt-cant__ctrl');
        if (!caja || input.dataset.mtListo) return;
        input.dataset.mtListo = '1';
        var min = parseInt(input.min, 10) || 1;
        var max = parseInt(input.max, 10) || 5;
        function fijar(v) {
          if (isNaN(v) || v < min) v = min;
          if (v > max) v = max;
          input.value = v;
          caja.querySelector('[data-mt-cant="-1"]').disabled = (v <= min);
          caja.querySelector('[data-mt-cant="1"]').disabled = (v >= max);
        }
        var bs = caja.querySelectorAll('[data-mt-cant]');
        for (var j = 0; j < bs.length; j++) {
          bs[j].addEventListener('click', function () {
            fijar(parseInt(input.value, 10) + parseInt(this.getAttribute('data-mt-cant'), 10));
          });
        }
        input.addEventListener('change', function () { fijar(parseInt(input.value, 10)); });
        // Al volver desde la caja, el navegador restaura el número DESPUÉS de cargar
        // la página: hay que recalcular o el botón - se queda bloqueado.
        window.addEventListener('pageshow', function () { fijar(parseInt(input.value, 10)); });
        fijar(parseInt(input.value, 10));
      })(campos[i]);
    }
  }

  // Pedir = vaciar el carro, agregar 1 y saltar directo a la caja.
  // Sin esto el carro acumula unidades y el cliente nunca lo ve.
  function initPedir() {
    var btns = document.querySelectorAll('[data-mt-pedir]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        var form = b.form;
        // sin fetch, el formulario normal sigue sirviendo
        if (!form || !window.fetch || b.dataset.mtListo) return;
        b.dataset.mtListo = '1';
        window.addEventListener('pageshow', function () {
          if (!b.dataset.mtEnviando) return;
          b.dataset.mtEnviando = '';
          if (b.dataset.mtTexto) b.textContent = b.dataset.mtTexto;
          b.style.opacity = '';
          b.style.pointerEvents = '';
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (b.dataset.mtEnviando) return;
          b.dataset.mtEnviando = '1';
          var textoOriginal = b.textContent;
          b.dataset.mtTexto = textoOriginal;
          b.textContent = 'Un momento…';
          b.style.opacity = '.7';
          b.style.pointerEvents = 'none';
          var campo = form.querySelector('[name=id]');
          var campoCant = form.querySelector('[name=quantity]');
          var cant = campoCant ? parseInt(campoCant.value, 10) : 1;
          if (!cant || cant < 1) cant = 1;
          var id = campo ? campo.value : null;
          var json = { 'Content-Type': 'application/json' };
          fetch('/cart/clear.js', { method: 'POST', headers: json })
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST', headers: json,
                body: JSON.stringify({ items: [{ id: id, quantity: cant }] })
              });
            })
            .then(function (r) {
              if (!r.ok) throw new Error('add');
              var pv = new URLSearchParams(location.search).get('preview_theme_id');
              location.href = '/checkout' + (pv ? '?preview_theme_id=' + pv : '');
            })
            .catch(function () {
              // si algo falla, se manda el formulario de siempre
              b.dataset.mtEnviando = '';
              b.textContent = textoOriginal;
              b.style.opacity = '';
              b.style.pointerEvents = '';
              form.submit();
            });
        });
      })(btns[i]);
    }
  }

  function boot() {
    // Cada init va aislado: si uno falla (navegador viejo, sección ausente),
    // los demás siguen funcionando. Antes, un error mataba todo lo que venía después.
    var pasos = [
      ['initReveal', initReveal],
      ['initCounters', initCounters],
      ['initGaleria', initGaleria],
      ['initSwipe', initSwipe],
      ['initFaq', initFaq],
      ['initComparador', initComparador],
      ['initParallax', initParallax],
      ['initOferta', initOferta],
      ['initAnuncio', initAnuncio],
      ['initCantidad', initCantidad],
      ['initPedir', initPedir]
    ];
    for (var i = 0; i < pasos.length; i++) {
      try { pasos[i][1](); }
      catch (err) { if (window.console) console.error("[KALMO] falló " + pasos[i][0] + ":", err); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
